/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import TextField from "@mui/material/TextField";
import Button from "components/ButtonUse";
import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

// import { Button } from "@mui/material";
// Data

// Dashboard components

function AddNewBmGuide() {
  const [file, setFile] = useState();
  const [key, setKey] = useState();
  const [description, setDescription] = useState();
  const [title, setTitle] = useState("");

  // async function saveData() {
  //   const formData = new FormData();

  //   formData.append("file", file);
  //   formData.append("key", key);
  //   formData.append("description", description);
  //   formData.append("title", title);

  //   let result = await fetch(
  //     "https://jumunona.onrender.com/admin/bodyData/addBodyMeasurementGuide",
  //     {
  //       method: "POST",
  //       body: formData,
  //     }
  //   );

  //   setFile("");
  //   setKey("");
  //   setDescription("");
  //   setTitle("");
  // }
  

 

  async function saveData() {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("key", key);
    formData.append("description", description);
    formData.append("title", title);

    try {
      let result = await fetch(
        `${process.env.REACT_APP_BASE_URL}/bodyData/addBodyMeasurementGuide`,
        {
          method: "POST",
          body: formData,
        }
      );
      if (result.ok) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Data has been posted successfully!",
        }).then((result) => {
          if (result.isConfirmed || result.isDismissed) {
            // Navigate to another page
            window.location.href = "/body-measurement-guide";
          }
        });
        setFile("");
        setKey("");
        setDescription("");
        setTitle("");
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to post data. Please try again later.",
        });
      }
    } catch (error) {
      console.error("Error posting data:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while posting data. Please try again later.",
      });
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <form
          style={{
            background: "white",
            padding: "10px",
            borderRadius: "10px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          }}
          autoComplete="off"
          action=""
        >
          <div style={{ padding: "5px" }}>
            {/* Upper section with two text fields */}
            <div style={{ display: "flex", gap: "40px" }}>
              <TextField
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Key"
                value={key}
                className="form-control"
                onChange={(e) => {
                  setKey(e.target.value);
                }}
                variant="outlined"
                required
              />
              <TextField
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Title"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
                variant="outlined"
                required
              />
            </div>

            {/* Lower section with two text fields and a file input */}
            <div style={{ display: "flex", gap: "40px", marginTop: "20px" }}>
              <TextField
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Description"
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
                variant="outlined"
                required
              />
              <TextField
                type="file"
                className="form-control"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </div>

            {/* Submit button */}
            <div style={{ textAlign: "center", color: "red", marginTop: "20px" }}>
              <span
                className="bg-red-700 rounded-md w-[10vw] cursor-pointer
                p-2 border-none outline-none ml-[1vw] text-white  text-sm"
                onClick={saveData}
              >
                Submit
              </span>
            </div>
          </div>

          {/* <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Button title={"Submit"}  onClick={saveData} />
          </div> */}
        </form>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default AddNewBmGuide;
